'use client';

import { useMemo, useState } from 'react';
import { ChevronRight } from '@doist/icons/brand';
import { Box, Button } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { IconRadioTile } from 'components/icon-radio-tile/icon-radio-tile';
import { IconRadioTileGroup } from 'components/icon-radio-tile/icon-radio-tile-group';
import { TemplateIconCard } from 'components/templates/template-icon-card/template-icon-card';
import { useLocale } from 'next-intl';
import { type TemplateListProps } from './template-list-container';
import css from './templates-section.module.css';
export function TemplateListDesktop({
  categories
}: TemplateListProps) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>(categories[0].id);
  const templates = useMemo(() => categories.find(category => category.id === selectedCategoryId)?.templates ?? categories[0].templates, [categories, selectedCategoryId]);
  return <>
            <Box className="mbe-24" data-sentry-element="Box" data-sentry-source-file="template-list-desktop.tsx">
                <IconRadioTileGroup value={selectedCategoryId} onChange={setSelectedCategoryId} data-sentry-element="IconRadioTileGroup" data-sentry-source-file="template-list-desktop.tsx">
                    {categories.map(category => <IconRadioTile key={`radio-${category.id}`} value={category.id} variant="seaSalt">
                            {category.name}
                        </IconRadioTile>)}
                </IconRadioTileGroup>
            </Box>
            <Box className={cn(css.gridContainer, 'pbe-48')} data-sentry-element="Box" data-sentry-source-file="template-list-desktop.tsx">
                <ul>
                    {templates.slice(0, 5).map(template => <li key={`template-${template.id}`}>
                            <TemplateIconCard template={template} />
                        </li>)}
                    <li className={css.seeAllButton}>
                        <Button variant="tertiary" href={`/templates/category/${selectedCategoryId}`} endIcon={ChevronRight} bleed="inline" data-sentry-element="Button" data-sentry-source-file="template-list-desktop.tsx">
                            {t('templatesSection.seeAll')}
                        </Button>
                    </li>
                </ul>
            </Box>
        </>;
}